import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v20l4-4h16V2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
}), 'SmsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SmsSharp.js
// module id = 6306
// module chunks = 2